// extracted by mini-css-extract-plugin
export default {"formWrapper":"tc1viKbj","form":"LaAXh4_R","title":"Kfur_6oH","subtitle":"NL10u833","field":"YQII0ton","resendButton":"itRhSF2d","counter":"khVYS9th","error":"AIjAQ_YD","flexWrapper":"VA9u_rxm","active":"wKitM_PI"};
    if(module.hot) {
      // 1734636559661
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  